import axios from "axios";

export default  async function SendTaskAction(p_baseUrl,p_mission_id,p_taskId,p_action="TASK_ACTION_COMPLETED"){
    try {
        const completeTaskResponse = await axios.put(`${p_baseUrl}/admin/tasks/${p_mission_id}/${p_taskId}`,{
            action:p_action
          });
        if(completeTaskResponse.status === 200){
            return completeTaskResponse.data;
        }
        return 'error';
    }catch (error) {
        console.log("error While trying to CompleteTask: " ,error);
        return 'error';
    }

}